export default __webpack_public_path__ + "static/Get-Away-On-A-Budget-09b64d8129f4cf455ec4614dd7959cd4.jpg";